import { useState, useEffect } from 'react'
import User from '../lib/User.js'

const useUser = (callback = () => {}) => {
  const [user, setUser] = useState(null)
  const updateState = (payload) => {
    setUser((prevValues) => ({ ...prevValues, ...payload.user }))
  }

  useEffect(() => {
    User.watch({ setState: updateState })
  }, [])

  useEffect(() => {
    if (user) {
      callback(user)
    }
  }, [user])

  return { user }
}

export default useUser
